<template>
<div>
  <div v-html="content"></div>
</div>
</template>
<script>
import api from '@/fetch/api';
export default {
  data() {
    return {
      username: '',
      mobile: '',
      activeName: 'all',
      content:'',
    };
  },
  created: function() {
    document.title = "槽车在线自助预约排队提货守则";
    var mobile = this.$store.state.wx_info.mobile ? this.$store.state.wx_info.mobile : "";
    var username = this.$store.state.wx_info.username ? this.$store.state.wx_info.username : "";
    this.$data.username = username;
    this.$data.mobile = mobile;
    this.getsysBcInfo("userprotocol");
  },
  methods:{
    getsysBcInfo(type)
    {
      var that = this;
      //获取系统信息
      api.getsysBcInfo(type).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var content = res.data;
          that.content = content;
        }
      }).catch(function() {
        //Toast.fail('连接失败，请刷新页面');
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
    margin-top: .875rem;
    margin-bottom: 60px;
    padding: 0 .875rem;
    h1{
      font-weight: bold;
      text-align: center;
      font-size: 1rem;
      margin-bottom: .875rem;
    }
    p{
      line-height: 2.5;
      text-indent: 2em;
    }
    .weight{
      font-weight: bold;
    }
}
.button-area
{
  margin: 0.28rem;
  .van-button
  {
    width: 50%;
    text-align: center;
    margin: 0 auto;
  }
}
</style>
